import { useCallback, useEffect, useRef, useState } from 'react'

import { SearchTab } from '~/portal/types/ui.components'

export const useTabScroll = (tabs: SearchTab[]) => {
  const tabListRef = useRef<HTMLDivElement>(null)
  const [tabWidths, setTabWidths] = useState<{ [key: string]: number }>({})
  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)
  
  const updateTabWidths = useCallback(() => {
  
    if (tabListRef.current) {
      const tabElements = tabListRef.current.children
      const newTabWidths: { [key: string]: number } = {}
      tabs.forEach((tab, index) => {
        newTabWidths[tab.type] = tabElements[index].clientWidth
      })
      setTabWidths(newTabWidths)
    }
  }, [tabs])
  
  const updateScrollPosition = useCallback(() => {
    if (tabListRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = tabListRef.current
      setCanScrollLeft(scrollLeft > 0)
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth)
    }
  }, [])
  
  useEffect(() => {
    updateTabWidths()
    updateScrollPosition()
    window.addEventListener('resize', updateTabWidths)
    const tabListElement = tabListRef.current
    tabListElement?.addEventListener('scroll', updateScrollPosition)
    return () => {
      window.removeEventListener('resize', updateTabWidths)
      tabListElement?.removeEventListener('scroll', updateScrollPosition)
    }
  }, [updateTabWidths, updateScrollPosition, tabListRef.current])
  
  const shouldShowArrows = useCallback(() => {
    if (tabListRef.current) {
      const tabListWidth = tabListRef.current.offsetWidth
      const totalTabWidths = Object.values(tabWidths).reduce((sum, width) => sum + width, 0)
      return totalTabWidths > tabListWidth - 36
    }
    return false
  }, [tabWidths])
  
  return {
    tabListRef,
    canScrollLeft,
    canScrollRight,
    shouldShowArrows,
  }
}